var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22.286px",
    height: "22.286px",
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.68024 20.9432C5.44523 19.6875 6.52038 18.6497 7.80232 17.9297C9.08426 17.2095 10.5299 16.8313 12.0002 16.8313C13.4706 16.8313 14.9162 17.2095 16.1982 17.9297C17.4802 18.6497 18.5552 19.6875 19.3203 20.9432M12.0003 14.2575C14.3672 14.2575 16.286 12.3388 16.286 9.97182C16.286 7.60489 14.3672 5.6861 12.0003 5.6861C9.63335 5.6861 7.71456 7.60489 7.71456 9.97182C7.71456 12.3388 9.63335 14.2575 12.0003 14.2575ZM12.0003 23.6861C18.1544 23.6861 23.1431 18.6974 23.1431 12.5432C23.1431 6.38922 18.1544 1.40039 12.0003 1.40039C5.84625 1.40039 0.857422 6.38922 0.857422 12.5432C0.857422 18.6974 5.84625 23.6861 12.0003 23.6861Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileInfoIcon);
export default __webpack_public_path__ + "static/media/profileInfoIcon.63523154f4b015399b8606c11c2312ec.svg";
export { ForwardRef as ReactComponent };